import fieldsToDataSources from "../utils/fieldsToDataSources";

import brandStyleFieldDefinitions from "@/features/Onboarding/utils/brandStyleFields";
import contentFieldDefinitions from "@/features/Onboarding/utils/contentFields";
import operationFieldDefinitions from "@/features/Onboarding/utils/operationFields";

const brandKitDataSources = {
  content: fieldsToDataSources(contentFieldDefinitions),
  operation: fieldsToDataSources(operationFieldDefinitions),
  style: fieldsToDataSources(brandStyleFieldDefinitions),
};

export default brandKitDataSources;
